import Alpine from 'alpinejs';
import api, { loadAnalyze, requireAuth, clearAnalyze, STORAGE_PROMPT } from './api.js';

function createInkoCreationSpec() {
  return {
    loading: false,
    busy: false,
    error: null,
    analyze: null,

    init() {
      if (!requireAuth()) return;
      this.analyze = loadAnalyze();
      if (!this.analyze) {
        window.location.href = '/inko-creation/prompt';
      }
    },

    get intent() {
      return this.analyze?.intent ?? {};
    },

    get designSpec() {
      return this.analyze?.design_spec ?? {};
    },

    async saveProject() {
      if (!this.analyze) return;
      this.busy = true;
      this.error = null;
      const prompt = sessionStorage.getItem(STORAGE_PROMPT) || this.intent.raw_prompt || '';
      try {
        const project = await api.createProject({
          product_key: this.intent.product_key,
          prompt,
          intent_json: this.analyze.intent,
          design_spec: this.analyze.design_spec,
          name: this.designSpec?.project?.name,
        });
        clearAnalyze();
        window.location.href = `/inko-creation/projects/${project.id}`;
      } catch (e) {
        this.error = e.response?.data?.message || 'Gagal menyimpan proyek.';
      } finally {
        this.busy = false;
      }
    },
  };
}

Alpine.data('inkoCreationSpec', createInkoCreationSpec);
